import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DataHelper } from '@app/helpers/data.helper';
import { LiveStreamService } from '@services/liveStream.service';

@Component({
  selector: 'live-stream-tv-component',
  template: ` <ng-container *ngIf="this.liveStreamData?.videoUrl && this.liveStreamData?.videoUrl !== ''">
    <div class="live-stream-slip-container">
      <div class="live-stream-slip-text">
        <strong>{{ 'Live_Stream' | translate }}</strong>
      </div>
      <div class="right-side" (click)="this.closeLiveStream()">
        <image-loader-utils url="close" extraClasses="close-icon"></image-loader-utils>
      </div>
    </div>
    <div class="iframe-loader-container">
      <div *ngIf="this.iframeLoading" id="loader" class="iframeLoader"></div>
      <iframe
        [style.visibility]="this.iframeVisibility"
        style="visibility: hidden;"
        (load)="this.hideLoader()"
        width="100%"
        height="250"
        [src]="this.liveStreamData.videoUrl"
        frameborder="0"
        allow="autoplay; gyroscope;"></iframe>
    </div>
  </ng-container>`,
})
export class LiveStreamTvComponent {
  public iframeLoading = true;
  public iframeVisibility = 'hidden';
  public liveStreamData:
    | {
        videoUrl: any;
        videoUrlLink: string;
        awayTeam: string;
        homeTeam: string;
        id: string | number;
      }
    | undefined;
  constructor(public _LiveStreamService: LiveStreamService, private domSanitizer: DomSanitizer, private _DataHelper: DataHelper) {
    this._LiveStreamService.tvStreamUrlListListener.subscribe(x => {
      if (x && x.length > 0) {
        if (this.liveStreamData?.id && x && x.length > 0) {
          const a = x.find(item => item.betradar_id == this.liveStreamData?.id);
          if (a && a.videoURL !== this.liveStreamData?.videoUrlLink) {
            this.activeLoader();
            this.liveStreamData = {
              ...this.liveStreamData,
              videoUrl: this.domSanitizer.bypassSecurityTrustResourceUrl(x.find(item => item.betradar_id == this.liveStreamData?.id).videoURL),
              videoUrlLink: x.find(item => item.betradar_id == this.liveStreamData?.id).videoURL,
            };
          } else if (!a) {
            this.liveStreamData = undefined;
            this.activeLoader();
          }
        } else {
          this.liveStreamData = undefined;
        }
      }
    });
    this._LiveStreamService.liveStreamDataListener.subscribe(item => {
      if (item && this._DataHelper.setSelectedTVTab) {
        this.liveStreamData = {
          ...item,
          videoUrl: this.domSanitizer.bypassSecurityTrustResourceUrl(item.videoUrl),
          videoUrlLink: item.videoUrl,
        };
        if (this.liveStreamData?.id) {
          this.activeLoader();
        }
      } else {
        this.liveStreamData = undefined;
      }
    });
  }

  activeLoader() {
    this.iframeLoading = true;
    this.iframeVisibility = 'hidden';
  }

  hideLoader() {
    this.iframeLoading = false;
    this.iframeVisibility = 'visible';
  }

  closeLiveStream() {
    this._LiveStreamService.resetLiveStreamUrl();
    this.activeLoader();
    this._DataHelper.setSelectedTVTab = true;
  }
}
